import { useEffect, useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { useAlertsParams } from "../../../hooks/useAlertsParams";
import { useSingleSelectFilterDisplayText } from "../../filters/hooks/useSingleSelectFilterDisplayText";
import { SimpleSingleSelectFilter } from "../../filters/SimpleSingleSelectFilter";

import { alertTypeTranslationKeyMap } from "./translationKeysConfig";
import { ALERT_TYPES, useSeoAlertsFilterStore } from "./useSeoAlertsFilterStore";

export const AlertType = () => {
    const { translate } = useTranslate();
    const { alertsType } = useAlertsParams();
    const selectedAlertType = useSeoAlertsFilterStore((state) => state.selectedAlertType);
    const setSelectedAlertType = useSeoAlertsFilterStore((state) => state.setSelectedAlertType);

    useEffect(() => {
        if (alertsType === "keywords") {
            setSelectedAlertType("NewKeywords");
        } else if (alertsType === "pages") {
            setSelectedAlertType("NewPages");
        }
    }, [alertsType, setSelectedAlertType]);

    const options = useMemo(
        () => ALERT_TYPES.map((type) => ({ id: type, label: translate(alertTypeTranslationKeyMap[type]) })),
        [translate],
    );

    const alertTypeDisplayText = useSingleSelectFilterDisplayText({
        defaultSelectionKey: "activation.alerts.filters.alert-type.all",
        isDefaultSelected: !selectedAlertType,
        nonDefaultSelectionKey: "activation.alerts.filters.alert-type.some",
        selectionKey: selectedAlertType && alertTypeTranslationKeyMap[selectedAlertType],
    });

    return (
        <SimpleSingleSelectFilter
            dataAutomation="alert-type-filter"
            onSelect={setSelectedAlertType}
            options={options}
            selectedValue={selectedAlertType}
        >
            {alertTypeDisplayText}
        </SimpleSingleSelectFilter>
    );
};
